<template>
  <div>
    <div class="days d-flex flex-wrap justify-content-center mb-5">
      <span @click.prevent="canEditHours ? addDay(day) : null" v-for="day in days"
            :key="day.id"
            :class="{'badge-success': checkIsSelected(day.id), 'cursor-pointer': canEditHours }"
            class="badge p-5 me-2 badge-circle badge-secondary disabled">
        {{ day['title_' + locale] }}
      </span>
    </div>
    <div class="mt-5">
      <div class="table-responsive h-100">
        <table class="table table-bordered align-middle">
          <tbody>
          <template :key="dayKey" v-for="(day, dayKey) in hoursForm">
            <tr class="">
              <td class="bg-light-primary rounded text-gray-600 fs-8 fw-bold px-3 py-2" colspan="4">
                <div class="d-flex justify-content-between align-items-center">
                  <div >
                    {{ findDays(day) }}
                  </div>
                  <div v-if="canEditHours" class="d-flex align-items-center">
                    <i @click.prevent="addHour(day)" class="fa cursor-pointer fa-plus fs-2x p-1 ms-5"></i>
                  </div>
                </div>
              </td>
            </tr>

            <tr :key="key" v-for="(hour, key) in day.hours">
              <td>
                <Input
                    :name="'start_'+dayKey+'_'+key"
                    type="time"
                    v-model="hour.start_time"
                    :is-disabled="!canEditHours"
                />
              </td>
              <td>
                <Input
                    :name="'end_'+dayKey+'_'+key"
                    type="time"
                    v-model="hour.end_time"
                    :is-disabled="!canEditHours"
                />
              </td>
              <td v-if="canEditHours" class="text-end">
                <button @click.prevent="deleteHour(dayKey, key)" type="button" class="btn btn-icon btn-flex btn-active-light-primary w-30px h-30px" >
                  <i class="fa fa-trash fs-3"></i>
                </button>
              </td>
            </tr>
          </template>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script setup>

import {computed, defineProps, ref, watch} from "vue";
import {useLocales} from "@/composables/locales";
import {useStore} from 'vuex'
import Input from "@/components/Input.vue";

const store = useStore()
const { locale } = useLocales()

const props = defineProps({
  hours: {
    type: Array,
    default: []
  },
  canEditHours: { type: Boolean, default: false }
})

const hoursForm = ref(props.hours)
const daysWithTrad = ref([
  {
    index: 'Monday',
    title_fr: 'Lun',
    title_en: 'Mon'
  },
  {
    index: 'Tuesday',
    title_fr: 'Mar',
    title_en: 'Tue'
  },
  {
    index: 'Wednesday',
    title_fr: 'Mer',
    title_en: 'Wed'
  },
  {
    index: 'Thursday',
    title_fr: 'Jeu',
    title_en: 'Thu'
  },
  {
    index: 'Friday',
    title_fr: 'Ven',
    title_en: 'Fri'
  },
  {
    index: 'Saturday',
    title_fr: 'Sam',
    title_en: 'Sat'
  },
  {
    index: 'Sunday',
    title_fr: 'Dim',
    title_en: 'Sun'
  }
])

const daysList = computed(() => store.getters['access/getDays'])
const days = computed(() => {
  if (!daysList.value.length) return daysWithTrad.value;

  return daysList.value.map(dayItem => {
    const match = daysWithTrad.value.find(d => d.index === dayItem.name);
    return {
      ...dayItem,
      ...(match || {})
    };
  });
});


watch(() => props.hours, () => {
  hoursForm.value = props.hours
}, { deep: true })

function addDay(dayValue) {
  const idx = hoursForm.value.findIndex(d => d.day_id === dayValue.id)
  if (idx !== -1) {
    hoursForm.value.splice(idx, 1)
  } else {
    hoursForm.value.push({
      day_id: dayValue.id,
      hours: [
        {
          start_time: '00:00',
          end_time: '23:59'
        }
      ]
    })
  }
}

function findDays(day) {
  const d = days.value.find(x => x.id === day.day_id)
  if (d) {
    return d['title_' + locale.value]
  }
  return ''
}

function addHour(day) {
  day.hours.push({
    start_time: '00:00',
    end_time: '23:59'
  })
}

function deleteHour(dayKey, key) {
  const day = hoursForm.value[dayKey]
  if (day) {
    day.hours.splice(key, 1)
    if (day.hours.length === 0) {
      hoursForm.value.splice(dayKey, 1)
    }
  }
}

function checkIsSelected(id) {
  if(!hoursForm.value || !hoursForm.value.length) return false
  return !!hoursForm.value?.find(d => d.day_id === id)
}

</script>

<style scoped>

</style>
